// src/components/LanguageSwitcher.js
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export default function LanguageSwitcher() {
  const { language, changeLanguage, availableLanguages } = useLanguage();

  return (
    <div style={{ display: 'flex', gap: '4px' }}>
      {availableLanguages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          title={lang.name}
          style={{
            padding: '6px 10px',
            background: language === lang.code ? '#4ade80' : 'transparent',
            color: language === lang.code ? '#0f2419' : '#888',
            border: `1px solid ${language === lang.code ? '#4ade80' : '#2d5a45'}`,
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: language === lang.code ? 'bold' : 'normal',
            fontSize: '14px',
            transition: 'all 0.2s'
          }}
        >
          {lang.flag} {lang.code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}